export { default } from "./useCanViewAdminConsole";
